import { useEffect, useState } from "react";
import { saveFontSizeLayout } from "../../../redux/_actions/persist.action";
import { useAppDispatch, useAppSelector } from "../../../services/hooks.service";
import "./AdjustFontsize.scss";

const AdjustFontsize = () => {
  const fontLayout = useAppSelector((state) => state.persist.font_layout);
  const current_breakpoint = useAppSelector((state) => state.persist.current_breakpoint);
  const root = document.documentElement;
  const dispatch = useAppDispatch();

  const [currentFont, setCurrentFont] = useState(0);
  const [classActive, setClassActive] = useState("");

  useEffect(() => {
    setCurrentFont(fontLayout.openOrder);
  }, [fontLayout.openOrder]);

  const handleIncreament = () => {
    setClassActive("incr");
    let fontL = { ...fontLayout };

    fontL.openOrder++;
    fontL.tableHead++;
    fontL.tableBody++;
    fontL.tickerHead++;
    fontL.tickerArrow++;
    fontL.tickerPrice++;
    fontL.minFont++;

    setCurrentFont(fontL.openOrder);

    root?.style.setProperty("--openOrder", `${fontL.openOrder}px`);
    root?.style.setProperty("--tableHead", `${fontL.tableHead}px`);
    root?.style.setProperty("--tableBody", `${fontL.tableBody}px`);
    root?.style.setProperty("--tickerHead", `${fontL.tickerHead}px`);
    root?.style.setProperty("--tickerArrow", `${fontL.tickerArrow}px`);
    root?.style.setProperty("--tickerPrice", `${fontL.tickerPrice}px`);
    root?.style.setProperty("--minFont", `${fontL.minFont}px`);

    dispatch(saveFontSizeLayout(fontL));
  };

  const handleDcreament = () => {
    setClassActive("dcr");
    let fontL = { ...fontLayout };

    fontL.openOrder--;
    fontL.tableHead--;
    fontL.tableBody--;
    fontL.tickerHead--;
    fontL.tickerArrow--;
    fontL.tickerPrice--;
    fontL.minFont--;
    setCurrentFont(fontL.openOrder);

    root?.style.setProperty("--openOrder", `${fontL.openOrder}px`);
    root?.style.setProperty("--tableHead", `${fontL.tableHead}px`);
    root?.style.setProperty("--tableBody", `${fontL.tableBody}px`);
    root?.style.setProperty("--tickerHead", `${fontL.tickerHead}px`);
    root?.style.setProperty("--tickerArrow", `${fontL.tickerArrow}px`);
    root?.style.setProperty("--tickerPrice", `${fontL.tickerPrice}px`);
    root?.style.setProperty("--minFont", `${fontL.minFont}px`);

    dispatch(saveFontSizeLayout(fontL));
  };

  return (
    <div className="adjust_box">
      <button
        disabled={currentFont === 10 || current_breakpoint === "sm" || current_breakpoint === "xs"}
        className={`decrease_font font_btn ${
          classActive === "dcr" ? "active" : ""
        } `}
        onClick={handleDcreament}
      >
        a <span className="spc minus">-</span>
      </button>
      <button
        disabled={currentFont === 20 || current_breakpoint === "sm" || current_breakpoint === "xs"}
        className={`increase_font font_btn ${
          classActive === "incr" ? "active" : ""
        } `}
        onClick={handleIncreament}
      >
        a <span className="spc plus">+</span>
      </button>
    </div>
  );
};

export default AdjustFontsize;
